export const complianceHide = (config: any) => config?.action === 'hide';

export const complianceShow = (config: any) => config?.action === 'show';

export const complianceExtData = (config: any) => {
  try {
    return JSON.parse(config.ext);
  } catch (error) {
    return '';
  }
};
